import React from 'react';
import { useNavigate } from 'react-router-dom';

const T = {
  paper:      '#F7EFD8',
  paperDeep:  '#EEE2BF',
  paperSoft:  '#FDF7E5',
  card:       '#FFFBEC',
  ink:        '#2E2109',
  ink2:       '#4A3510',
  inkMuted:   '#6E5A38',
  inkFaint:   '#A39068',
  rule:       '#D7C9A1',
  ruleStrong: '#BFAB79',
  orange:     '#EA7C1F',
  orangeDark: '#C25F0E',
  moss:       '#6B7A3E',
  mossDark:   '#4E5A29',
  mossSoft:   '#D7DCB9',
  capRed:     '#C14A33',
  capRedSoft: '#F2C7BA',
  roof:       '#C76A3B',
  roofSoft:   '#F2D1B3',
  r2: '6px', r3: '10px', r4: '14px', r5: '20px', full: '999px',
  sh1: '0 1px 0 rgba(46,33,9,0.06), 0 2px 4px rgba(46,33,9,0.04)',
  sh2: '0 2px 0 rgba(46,33,9,0.04), 0 8px 16px -8px rgba(46,33,9,0.14)',
  sh3: '0 3px 0 rgba(46,33,9,0.05), 0 20px 36px -12px rgba(46,33,9,0.18)',
  sans: '"Nunito", ui-sans-serif, system-ui, -apple-system, sans-serif',
  hand: '"Caveat", "Nunito", cursive',
  mono: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
};

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: T.paper,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: T.sans,
      padding: '24px',
    }}>
      <div style={{
        backgroundColor: T.card,
        borderRadius: T.r4,
        boxShadow: T.sh2,
        padding: '48px',
        textAlign: 'center',
        maxWidth: '440px',
        width: '100%',
      }}>
        <div style={{ fontSize: '64px', lineHeight: 1 }}>
          🍄
        </div>

        <div style={{
          fontFamily: T.hand,
          fontSize: '28px',
          color: T.orange,
          marginTop: '16px',
          display: 'block',
        }}>
          lost in the woods —
        </div>

        <h1 style={{
          fontFamily: T.sans,
          fontSize: '36px',
          fontWeight: 800,
          color: T.ink,
          margin: '8px 0 12px',
          letterSpacing: '-0.5px',
        }}>
          Page not found.
        </h1>

        <p style={{
          fontSize: '15px',
          color: T.ink2,
          lineHeight: 1.55,
          maxWidth: '320px',
          margin: '0 auto',
        }}>
          This path doesn't exist. Maybe it moved, maybe it never was. Either way, let's get you back.
        </p>

        <div style={{
          display: 'flex',
          gap: '10px',
          justifyContent: 'center',
          marginTop: '24px',
          flexWrap: 'wrap',
        }}>
          <Button
            onClick={() => navigate('/')}
            variant="primary"
          >
            ← Go home
          </Button>
          <Button
            onClick={() => navigate('/dashboard')}
            variant="ghost"
          >
            Dashboard
          </Button>
        </div>

        <div style={{
          fontFamily: T.mono,
          fontSize: '11px',
          color: T.inkMuted,
          marginTop: '20px',
          letterSpacing: '0.02em',
        }}>
          404 · not found
        </div>
      </div>
    </div>
  );
};

const Button = ({ onClick, variant, children }) => {
  const [hovered, setHovered] = React.useState(false);

  const base = {
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: 700,
    fontFamily: T.sans,
    border: 'none',
    borderRadius: T.r3,
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    lineHeight: 1,
  };

  const styles = variant === 'primary'
    ? {
        ...base,
        backgroundColor: hovered ? T.ink2 : T.ink,
        color: '#fff',
      }
    : {
        ...base,
        backgroundColor: 'transparent',
        color: hovered ? T.ink : T.ink2,
        border: `1.5px solid ${hovered ? T.ruleStrong : T.rule}`,
      };

  return (
    <button
      onClick={onClick}
      style={styles}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
    </button>
  );
};

export default NotFound;
